import { render } from "./SearchIndex.vue?vue&type=template&id=0ff3f0f0"
import script from "./SearchIndex.vue?vue&type=script&lang=js"
export * from "./SearchIndex.vue?vue&type=script&lang=js"

import "./SearchIndex.vue?vue&type=style&index=0&id=0ff3f0f0&lang=css"

import exportComponent from "/Users/andrei/Desktop/EO LARAVEL/club-shops-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__